import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BrandWordmark } from '../components/brand/BrandWordmark';
import { FeatureGuideContent } from '../components/guide/FeatureGuideContent';
import { GuideLauncher } from '../components/guide/GuideLauncher';
import AppFooter from '../components/AppFooter';

/**
 * Permanent Feature Guide — /guide
 */
export default function FeatureGuidePage() {
  return (
    <div className="flex min-h-screen flex-col bg-[hsl(42_28%_96%)]">
      <header className="border-b border-[hsl(38_14%_86%)] bg-[hsl(42_28%_99%)]/95 backdrop-blur-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-8 lg:px-10">
          <div className="flex min-w-0 items-center gap-3">
            <Link
              to="/dashboard"
              className="inline-flex shrink-0 items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
            >
              <ArrowLeft className="h-4 w-4" />
              <span className="hidden sm:inline">Dashboard</span>
            </Link>
            <BrandWordmark variant="navApp" className="hidden text-lg sm:inline" />
          </div>
          <GuideLauncher />
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-10 sm:px-8 sm:py-12 lg:px-10 lg:py-14">
        <header className="max-w-3xl">
          <p className="text-[0.68rem] font-semibold uppercase tracking-[0.2em] text-[hsl(38_36%_42%)]">
            MyLegacyBridge
          </p>
          <h1 className="mt-2 font-serif text-3xl font-light text-[hsl(24_14%_16%)] sm:text-4xl">
            Feature Guide
          </h1>
          <p className="mt-3 text-base leading-relaxed text-[hsl(32_10%_38%)] sm:text-lg">
            Everything you can preserve, create and share with MyLegacyBridge.
          </p>
        </header>

        <div className="mt-10 lg:mt-12">
          <FeatureGuideContent />
        </div>
      </main>

      <AppFooter variant="light" />
    </div>
  );
}
